import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCheckCircle } from "@fortawesome/free-solid-svg-icons"
import {  Apple, MilkIcon, Salad } from "lucide-react"
import GatewayPagamento from "../../../components/Gateway/EfiPay/GatewayPagamento"
import { useEffect, useState } from "react"

export default function GanhoDeMassa() {
  const [addOrderBump, setAddOrderBump] = useState(false)
  const [amount, setAmount] = useState(14.99)
  const [showOrderBumpOverlay, setShowOrderBumpOverlay] = useState(true)

  useEffect(() => {
    setShowOrderBumpOverlay(true)
  }, [])

  const handleChangeOrderBump = () => {
    const baseAmount = 14.99
    const extraAmount = 4.99
    setAddOrderBump(!addOrderBump)
    setAmount(!addOrderBump ? baseAmount + extraAmount : baseAmount)
  }

  const handleConfirmOrderBump = () => {
    setAddOrderBump(true)
    setShowOrderBumpOverlay(false)
    handleChangeOrderBump()
  }

  const handleCancelOrderBump = () => {
    setShowOrderBumpOverlay(false)
  }

  const OrderBumpOverlay = ({ onConfirm, onCancel }) => (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-md">
        <div className="p-6">
          <h2 className="text-2xl text-[#190076] font-bold mb-2">Incluir Adicional?</h2>
          <p className="text-[#190076] mb-4">Por apenas R$ 4,99 a mais</p>
          <ul className="space-y-3 mb-6">
            {[
              { icon: MilkIcon, text: "Recomendação Whey" },
              { icon: MilkIcon, text: "Recomendação Creatina" },
              { icon: Salad, text: "Receitas fit" },
              { icon: Apple, text: "Recomendação de Frutas" },

            ].map((item, index) => (
              <li key={index} className="flex items-center">
                <item.icon className="w-5 h-5 mr-3 text-gray-400" />
                <span className="text-sm text-[#190076]">{item.text}</span>
              </li>
            ))}
          </ul>
        </div>
        <div className="bg-gray-50 px-6 py-4 rounded-b-lg flex justify-end space-x-3">
          <button className="px-4 py-2 text-[#7B1FE0] hover:text-[#7B1FE0]" onClick={onCancel}>
            Não, obrigado
          </button>
          <button className="px-4 py-2 bg-[#7B1FE0] text-white rounded hover:bg-[#7B1FE0]" onClick={onConfirm}>
            Sim, quero!
          </button>
        </div>
      </div>
    </div>
  )

  return (
   
   <div className="relative min-h-screen overflow-hidden bg-white text-black">
         {showOrderBumpOverlay && <OrderBumpOverlay onConfirm={handleConfirmOrderBump} onCancel={handleCancelOrderBump} />}


      <div className="absolute inset-0 bg-white backdrop-filter backdrop-blur-sm"></div>
      <div className="relative z-10 min-h-screen flex flex-col items-center justify-center p-2 sm:p-4">
        <div className="bg-white rounded-lg shadow-xl overflow-hidden w-full max-w-[99%] sm:max-w-6xl p-4 border border-gray-200">
          <div className="mt-4">
            <GatewayPagamento amount={amount.toFixed(2)} addOrderBump={addOrderBump} />
         </div>

          <div className="mt-4 text-center">
            <p className="text-sm text-gray-600">
            Treino gerado após o pagamento. Por favor, volte ao site para acessar seu treino.
              <FontAwesomeIcon icon={faCheckCircle} className="text-green-500 ml-1" />
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
